import DOMPurify from 'dompurify';

/**
 * Sanitiza HTML para mitigar XSS cuando debemos renderizar HTML en el DOM.
 *
 * Nota: DOMPurify elimina scripts, handlers (on*), urls javascript: y otros vectores.
 * Además bloqueamos atributos `style` por seguridad (podés aflojarlo si necesitás estilos inline).
 */
export const sanitizeHtml = (input) => {
  const html = String(input ?? '');

  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    FORBID_ATTR: ['style'],
    // Por defecto DOMPurify ya bloquea `javascript:` en href/src y elimina `on*`.
  });
};

